<template>
  <div :class="['divider-line', { 'divider-line--overlay': overlay }]">
    <div class="divider-line__notch divider-line__notch--left"></div>
    <div class="divider-line__line"></div>
    <div class="divider-line__notch divider-line__notch--right"></div>
  </div>
</template>

<script>
export default {
  name: "TheDividerLine",
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.divider-line {
  display: flex;
  align-items: center;

  &--overlay {
    position: absolute;
    z-index: 100;
    width: 100%;
    bottom: calc(33vh - 12px);
  }
}

.divider-line__line {
  width: 100%;
  border-top: 1px dashed #000000;
}

.divider-line__notch {
  width: 0;
  height: 0;
  flex-shrink: 0;

  &--left {
    border-top: 12px solid transparent;
    border-left: 11px solid #000000;
    border-bottom: 12px solid transparent;
  }

  &--right {
    border-top: 12px solid transparent;
    border-right: 11px solid #000000;
    border-bottom: 12px solid transparent;
  }
}
</style>
